<template>
  <d-container fluid class="user user-edit-email main-content-container align-items-center justify-content-center">
    <d-col cols="12">
      <d-row class="justify-content-center">
        <d-col class="col-12 col-md-10 col-lg-8 px-0">
          <router-link class="nav-link px-0 d-inline-block" :to="{ name: 'order.index' }">
            &lt; {{ $t('button.go_back') }}
          </router-link>

          <h2 class="my-2">
            {{ $t('user.edit_email.title') }}
          </h2>
        </d-col>

        <d-col class="col-12 col-md-10 col-lg-8 px-0">
          <email-form v-if="d_showForm" @updateSuccess="toggleForm"/>

          <d-card v-else class="mb-3">
            <d-card-body>
              <d-row>
                <d-col cols="12">
                  {{ $t('user.edit_email.success') }}
                </d-col>
              </d-row>
            </d-card-body>
          </d-card>
        </d-col>
      </d-row>
    </d-col>
  </d-container>
</template>

<script>
import EmailForm from '@/components/user/EmailForm';

export default {
  name: 'user-edit-email',
  components: { EmailForm },
  data () {
    return {
      d_showForm: true,
    };
  },
  methods: {
    toggleForm (value = false) {
      this.d_showForm = value;
    },
  },
}
</script>
